import React from "react";

type CommandImageProps = {
    data?: {
        image_url?: string;
        image_label?: string;
    };
};

const CommandImage: React.FC<CommandImageProps> = ({ data }) => {
    if (!data?.image_url) {
        return null;
    }

    return (
        <div className="h-full w-full flex flex-col gap-12 items-center justify-center overflow-hidden">
            {data.image_label && (
                <div className="text-5xl text-plot-white text-center truncate">{data.image_label}</div>
            )}
            <img src={data.image_url} alt={data.image_label || "Dashboard image"} className="max-h-full max-w-full object-contain" />
        </div>
    );
};

export default CommandImage;
